import App from './Hiphop.vue';
import { setup } from '@/utils/setup';

const app = setup(App);
app.mount('#app');
